import common from './common';
import logReport from '../monitor/qdMonitor';
import { VIDEOSTATUS } from '../constants';
import { formatUrl, isOa, receiveMsg } from '../utils';
import { isPrivate } from '@/utils/env';
export default {
  mixins: [common],
  data() {
    return {
      surportTRTC: false,
      // 是c2b还是b2c
      dir: '',
      // 是call拨打还是receive接听
      userAction: '',
      // 音视频类型 视频：1 音频：2
      mediaType: '',
      videoStatus: VIDEOSTATUS.idle,
    };
  },
  mounted() {
    this.checkTRTC();
  },
  methods: {
    // 验证浏览器是否支持trtc通话,检查浏览器是否与TRTC兼容
    checkTRTC() {
      if (typeof TRTC === 'undefined') {
        this.surportTRTC = false;
      } else {
        TRTC.checkSystemRequirements()
          .then((checkResult) => {
            this.surportTRTC = checkResult.result;
          })
          .catch((error) => {
            this.surportTRTC = false;
            console.error(`getDevices error observed ${error}`);
          });
      }
    },
    // 检测失败则提示下载谷歌
    checkTRTCFaile() {
      alert('您的浏览器不兼容此应用！\n建议下载最新版Chrome浏览器');
      window.location.href = 'http://www.google.cn/chrome/';
    },
    // 检测是否在音视频通话中 是否能新发起视频通话
    canVidoStatus() {
      if (this.videoStatus != VIDEOSTATUS.idle) {
        this.$Alert('当前通话没结束，不能发起新通话');
        return false;
      }
      return true;
    },
    // 音频通话
    audioCall() {
      if (!this.canVidoStatus()) {
        return;
      }
      if (!navigator.onLine) {
        this.$Confirm({
          title: '',
          text: '当前网络不可用，请检查您的网络设置',
          confirmText: this.$t('common_video_confirm'),
        });
        return;
      }
      TRTC.getMicrophones().then((res) => {
        console.log('开始语音通话', res);
        if (res.length === 0) {
          this.$Confirm({
            title: '未检测到麦克风',
            text: '可能影响通话质量，请检查连接状态',
            confirmText: this.$t('common_video_text_call'),
          }).then(() => {
            this.callUser(2);
          })
            .catch(() => {
              console.log('音频通话取消');
            });
          return;
        }
        this.callUser(2);
      });
    },
    // 视频通话
    videoCall() {
      if (!this.canVidoStatus()) {
        return;
      }
      if (!navigator.onLine) {
        this.$Confirm({
          title: '',
          text: '当前网络不可用，请检查您的网络设置',
          confirmText: this.$t('common_video_confirm'),
        });
        return;
      }
      TRTC.getMicrophones().then((res) => {
        console.log('开始视频通话', res);
        let hasMic = true;
        if (res.length === 0) {
          hasMic = false;
        }
        TRTC.getCameras().then((res) => {
          if (res.length === 0) {
            this.$Confirm({
              title: hasMic ? '未检测到摄像头' : '未检测到摄像头和麦克风',
              text: '可能影响通话质量，请检查连接状态',
              confirmText: this.$t('common_video_text_call'),
            }).then(() => {
              this.callUser(1);
            })
              .catch(() => {

              });
            return;
          }
          if (!hasMic) {
            this.$Confirm({
              title: '未检测到麦克风',
              text: '可能影响通话质量，请检查连接状态',
              confirmText: this.$t('common_video_text_call'),
            }).then(() => {
              this.callUser(1);
            })
              .catch(() => {

              });
            return;
          }
          this.callUser(1);
        });
      });
    },
    // 发起呼叫
    callUser(calltype) {
      this.dir = 'c2b';
      this.mediaType = calltype;
      this.userAction = 'call';
      logReport({ message: `音视频:主叫,${calltype}` });
      this.openRoom();
    },
    // 打开视频聊天页
    openRoom() {
      logReport({
        message: `音视频:打开房间,用户ua${navigator.userAgent}`,
      });
      // 视频客服新域名
      let url = `https://${isOa ? 'oa' : ''}console.qidian.qq.com/spa/cs-video/index.html`;
      if (isPrivate) {
        url = `${window.location.origin}/spa/cs-video/index.html`;
      }
      const winname = 'new_videocall_window';
      const { kfuin, wpaId, key, visitorid } = this.wpaDetail;
      const { extuin } = this.reception;
      const params = {
        uin: kfuin, // 主号这个参数是nginx用来地址栏参数多set区分,
        kfuin, // 主号,
        fid: wpaId, // wpa id
        key,
        roleData: extuin, // 工号
        roleValue: 0, // 接待类型
        visitorId: visitorid,
        mediaType: this.mediaType,
        // 是拨打还是接收
        action: this.userAction,
        // 是b2c还是c2b
        dir: this.userAction === 'call' ? 'c2b' : 'b2c',
        // 通路类型 1:工号 3:微信公众号 4:webim 7:微信小程序 50:imsdk 56:视频客服
        channelType: 4,
      };
      if (this.userAction === 'receive') {
        params.roomId =  this.roomid;
      }
      this.openURLtoBlank(formatUrl(url, params), winname);
      receiveMsg(this.handleVideoPostMessage);
    },
    // 打开一个新窗口
    openURLtoBlank(url, winname) {
      let newWin;
      if (url) {
        const Width = document.documentElement.clientWidth * 1 - 800;
        const Height = document.documentElement.clientHeight;
        const topHeight = document.body.getBoundingClientRect().top;
        console.log('Height', Width, Height, topHeight);
        //    return window.open(url, '_blank',);
        newWin = window.open(url, winname, `left=${Width},top=${topHeight + 90},width=800,height=500,toolbar=0,titlebar=no`);
        console.log(winname, 'winname');
      } else {
        newWin = window.open('', winname);
        newWin.document.body.innerHTML = '正在加载中......';
      }

      return newWin;
    },
    handleVideoPostMessage(msgData) {
      const { act } = msgData;
      switch (act) {
        case 'audioVideoSuccess':
          this.videoStatus = VIDEOSTATUS.speaking;
          break;
        case 'audioVideoEnd':
        default:
          this.videoStatus = VIDEOSTATUS.idle;
      }
    },
  },
};
